export default __webpack_public_path__ + "static/media/safari.9eadd4cf.png";